import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2c28119c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "theme"
}
const _hoisted_2 = { class: "root" }
const _hoisted_3 = { class: "theme-list theme-list-padding" }
const _hoisted_4 = { class: "theme-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_theme_display = _resolveComponent("theme-display", true)!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (node) => {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
      (node.children.length === 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.isSelectedTheme(node))
              ? (_openBlock(), _createElementBlock("li", _hoisted_1, _toDisplayString(node.theme.title), 1))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (node.children.length > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.hasDirectSelectedLeaf(node.children) || _ctx.hasSelectedInThemes(node.children))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.hasDirectSelectedLeaf(node.children))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.getBreadCrumbForTheme(node.theme)), 1),
                        _createElementVNode("ul", _hoisted_3, [
                          _createVNode(_component_theme_display, {
                            themes: _ctx.themes,
                            nodes: node.children.filter(c => _ctx.entityThemes.findIndex(id => id === c.theme.id) > -1),
                            "entity-themes": _ctx.entityThemes
                          }, null, 8, ["themes", "nodes", "entity-themes"])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_4, [
                    (_ctx.hasSelectedInThemes(node.children))
                      ? (_openBlock(), _createBlock(_component_theme_display, {
                          key: 0,
                          themes: _ctx.themes,
                          nodes: node.children.filter(c => _ctx.entityThemes.findIndex(id => id === c.theme.id) === -1),
                          "entity-themes": _ctx.entityThemes
                        }, null, 8, ["themes", "nodes", "entity-themes"]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 64))
  }), 256))
}